/**
 * This renders some input text written using a subset of markdown supporting:
 * - paragraphs
 * - bold text
 * - italic text
 */
import * as preact from "preact";

interface Props {
  text: string;
}

class MiniMarkdownView extends preact.Component<Props> {
  render() {
    const { text } = this.props;

    const paragraphs = text.split("\n").map((paragraph) => {
      return (
        <p>
          {paragraph.split("**").map((boldChunk, boldChunkIndex) => {
            if (boldChunkIndex % 2 === 0) {
              return boldChunk.split("*").map((italicChunk, italicIndex) => {
                if (italicIndex % 2 === 0) {
                  return italicChunk;
                } else {
                  return <i>{italicChunk}</i>;
                }
              });
            } else {
              return <b>{boldChunk}</b>;
            }
          })}
        </p>
      );
    });

    return <div>{paragraphs}</div>;
  }
}

export default MiniMarkdownView;
